import { isNull } from "lodash";

import { getFromLocalStorage } from "../utils/storage";

// Base path for backend API calls
export const basePath = "https://cnmpapi.terbine.io:8443/api";

// Creates header configuration for API calls
export const createHeaders = () => {
  const headers = {};
  const token = getFromLocalStorage("authData")?.token;

  if (!isNull(token)) headers["Authorization"] = "Bearer " + token;
  headers["Content-Type"] = "application/json";
  headers["Access-Control-Allow-Origin"] = "*";

  return headers;
};
